/* Canvas Mérida · Retratos de mascota
- Producto (snippets/cm-pet-picker): selector visual de estilo -> properties[Estilo]; ?estilo=clave lo preselecciona;
mueve la galería del producto a la imagen del estilo (medio con alt = nombre del estilo); en la descripción
(sections/cm-pet en modo producto) las tarjetas de estilo eligen el estilo en vez de navegar.
- Landing (sections/cm-pet): antes/después con deslizador, filtro de estilos por categoría. */
(function () {
'use strict';
var NAMED = { lineart: 1, memorial: 1 };
/* ---------- selector del producto ---------- */
var pp = document.querySelector('[data-cm-pp]');
if (pp && !pp.dataset.ready) {
pp.dataset.ready = '1';
var nameEl = pp.querySelector('[data-pp-name]'), descEl = pp.querySelector('[data-pp-desc]');
var hint = pp.querySelector('[data-pp-hint]'), pet = pp.querySelector('[data-pp-pet]');
var radios = [].slice.call(pp.querySelectorAll('input[name="properties[Estilo]"]'));
// enlaza los campos al formulario de compra (el selector vive fuera del <form>)
var form = (pp.closest('.product-info') || document).querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"][id^="product-form-"]');
var fid = form && form.getAttribute('id'); // ojo: form.id lo tapa el <input name="id"> del formulario
if (fid) [].forEach.call(pp.querySelectorAll('[data-pp-field]'), function (f) { if (!f.getAttribute('form')) f.setAttribute('form', fid); });
// lleva la galería del producto a la imagen del estilo (medio del producto con alt = nombre del estilo)
function gallerySlide(r) {
var mid = r.getAttribute('data-media'); if (!mid) return;
var main = document.querySelector('.product-gallery .product-image-main') || document.querySelector('.product-gallery .swiper');
if (!main || !main.swiper) return;
var slides = [].slice.call(main.querySelectorAll('.swiper-slide'));
var i = slides.findIndex(function (s) { return s.querySelector('[data-media-id="' + mid + '"]') || (s.getAttribute('data-media-id') || '').indexOf('-' + mid) > -1; });
if (i > -1) main.swiper.slideTo(i);
}
function apply(r, fromUser) {
r.checked = true;
nameEl.textContent = r.value;
descEl.textContent = r.getAttribute('data-desc') || '';
var named = !!NAMED[r.getAttribute('data-key')];
hint.hidden = !named;
pet.placeholder = named ? 'Ej. Max (aparecerá en el cuadro)' : 'Ej. Max';
if (fromUser) {
gallerySlide(r);
try { if (window.gtag) gtag('event', 'retrato_estilo', { estilo: r.getAttribute('data-key') }); } catch (e) {}
}
}
radios.forEach(function (r) { r.addEventListener('change', function () { apply(r, true); }); });
// nombre + tips de foto van debajo de las opciones (pasos 5 y 6), justo antes de la carga de fotos
var after = pp.querySelector('[data-pp-after]'), pv = document.querySelector('.product-info .product-variants');
if (after && pv && pv.parentNode) pv.parentNode.insertBefore(after, pv.nextSibling);
// tarjetas de la galería en la descripción del producto: eligen el estilo y suben al selector
document.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('.cm-pet--pdp [data-pet-pick]'); if (!a) return;
var r = radios.filter(function (x) { return x.getAttribute('data-key') === a.getAttribute('data-pet-pick'); })[0]; if (!r) return;
e.preventDefault(); apply(r, true);
var lab = r.closest('label'); if (lab) lab.parentNode.scrollLeft = lab.offsetLeft - 20;
var top = pp.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cm-hd-h')) || 90) - 16;
window.scrollTo({ top: top, behavior: 'smooth' });
});
var q = new URLSearchParams(location.search).get('estilo');
var start = radios.filter(function (r) { return r.getAttribute('data-key') === q; })[0];
if (start) {
apply(start, false);
// la galería del tema se inicializa con retraso
setTimeout(function () { gallerySlide(start); }, 1500);
var lab = start.closest('label'); if (lab && lab.scrollIntoView) lab.parentNode.scrollLeft = lab.offsetLeft - 20;
} else if (radios[0]) apply(radios.filter(function (r) { return r.checked; })[0] || radios[0], false);
}
/* ---------- landing ---------- */
var land = document.querySelector('[data-cm-pet]');
if (land && !land.dataset.ready) {
land.dataset.ready = '1';
// antes / después
[].forEach.call(land.querySelectorAll('[data-pet-ba]'), function (ba) {
var range = ba.querySelector('input[type=range]');
function set(v) { ba.style.setProperty('--pos', v + '%'); }
range.addEventListener('input', function () { set(range.value); });
set(range.value);
var after = ba.querySelector('[data-pet-after]'), lbl = ba.parentNode.querySelector('[data-pet-after-name]');
[].forEach.call(ba.parentNode.querySelectorAll('[data-pet-swap]'), function (b) {
b.addEventListener('click', function () {
[].forEach.call(ba.parentNode.querySelectorAll('[data-pet-swap]'), function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
after.src = b.getAttribute('data-pet-swap');
if (lbl) lbl.textContent = b.textContent.trim();
// pequeña animación para que se note el cambio
range.value = 18; set(18);
var t0 = null;
function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 600), v = 18 + (50 - 18) * (1 - Math.pow(1 - p, 3)); range.value = v; set(v); if (p < 1) requestAnimationFrame(step); }
requestAnimationFrame(step);
});
});
});
// filtro por categoría
var chips = land.querySelectorAll('[data-pet-cat]'), cards = land.querySelectorAll('[data-pet-card]');
[].forEach.call(chips, function (c) {
c.addEventListener('click', function () {
var k = c.getAttribute('data-pet-cat');
[].forEach.call(chips, function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
[].forEach.call(cards, function (card) { card.hidden = k !== 'all' && card.getAttribute('data-pet-card') !== k; });
});
});
}
})();